import Digestion from './Digestion';

export default Digestion;
